import {Organisation} from './organisation';

export class ModuleVisibility {
  _id: string;
  organisation: string;
  role: string;
  visible: boolean;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/model/moduleVisibility.ts